import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _a;
/**
 * 原FireWork 唤起综合链接
 * 调起客户端app webview，打开h5链接
 *
 * ### Example
 * ```
 * const appName = 'group';
 * const appUrl = 'http://a.com';
 * const webUrl = 'http://b.com';
 * callUpApp(appName, appUrl, webUrl);
 * ```

 * 改成 魔方唤起综合链接
 * https://m.dianping.com/cube/evoke/xxx.html
 * 在url路径中定义：/cube/evoke/xxx.html ，app 类型如下：
 * 美团：meituan
 * 大众点评：dianping

 * 访问链接参数url=encode(native_url || web_url)
 * 网页版访问链接参数web=encode(web_url)
 * 完整链接格式：https://m.dianping.com/cube/evoke/xxx.html?url=encode(native_url || web_url)&web=encode(web_url)

 * 对比文档地址：https://km.sankuai.com/page/63725174
 */
import { objectToQuery } from 'util/object-to-query';
import { getApp } from '@mx/util/get-app';
import { getAllQueryString } from '@mx/util';
import { msi } from '@mtfe/msi-knb-loader';
var KNB = require('@dp/knb');
var SUCCESS_CODE = 0; // 默认业务成功状态码
var FAIL_CODE = 1; // 默认业务失败码
var ERR_CODE = {
  TIMEOUT: 8000,
  NETWORK_ERR: 8001,
  REQUEST_ERR: 8002
};
// 针对发票业务方数据统计专项， 新增两个缓存
export var SOURCE_STORAGE_KEYS = {
  businessSource: 'meituan-invoice-business-source',
  businessSourceFrom: 'meituan-invoice-business-source-from'
};
export function callUpApp(appName, appUrl, webUrl) {
  var appNameMap = {
    'group': 'meituan',
    'dianping-nova': 'dianping'
  };
  var protocolPrefixMap = {
    'group': 'imeituan://www.meituan.com/web?url=',
    'dianping-nova': 'dianping://web?url='
  };
  var transferUrl = "https://m.dianping.com/cube/evoke/" + appNameMap[appName] + ".html";
  appUrl = protocolPrefixMap[appName] + encodeURIComponent(appUrl);
  var params = {
    web: webUrl,
    url: appUrl
  };
  location.href = transferUrl + '?' + objectToQuery(params);
}
export function getBytesLength(str) {
  // 在GBK编码里，除了ASCII字符，其它都占两个字符宽
  return str.replace(/[^\x00-\xff]/g, 'xx').length; // eslint-disable-line
}
export function timestampToTime(timestamp) {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '.';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.';
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' ';
  return Y + M + D;
}
export function formatTime(time, template) {
  var padZero = function padZero(s, length) {
    if (length === void 0) {
      length = 2;
    }
    return ("000" + s).slice(-length);
  };
  var date = new Date(time);
  var YYYY = date.getFullYear();
  var MM = padZero(date.getMonth() + 1);
  var DD = padZero(date.getDate());
  var HH = padZero(date.getHours());
  var mm = padZero(date.getMinutes());
  var ss = padZero(date.getSeconds());
  return template.replace(/(YYYY)|(MM)|(DD)|(HH)|(mm)|(ss)/g, function (match) {
    switch (match) {
      case 'YYYY':
        return YYYY;
      case 'MM':
        return MM;
      case 'DD':
        return DD;
      case 'HH':
        return HH;
      case 'mm':
        return mm;
      case 'ss':
        return ss;
    }
  });
}
export function isWeChatMiniApp() {
  var ua = window.navigator.userAgent.toLowerCase();
  var isWX = /micromessenger/.test(ua);
  var isWXApp = isWX && /miniprogram/.test(ua);
  return new Promise(function (resolve) {
    if (ua.indexOf('micromessenger') == -1) {
      console.log("不在微信或者小程序中");
      resolve(false);
    } else {
      isWXApp ? resolve(true) : resolve(false);
      // wx.miniProgram.getEnv((res) => {
      //   if (res.miniprogram) {
      //     console.log("在小程序中")
      //     resolve(true);
      //   } else {//在微信中
      //     console.log("在微信中")
      //     resolve(false);
      //   }
      // });
    }
  });
}
export function isWeChatMiniAppSync() {
  return __awaiter(this, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, isWeChatMiniApp()];
        case 1:
          res = _a.sent();
          return [2 /*return*/, res];
      }
    });
  });
}
export function isMobile() {
  var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}
export function getRouterQuery(variable) {
  var query = window.location.hash.substring(window.location.hash.indexOf('?') + 1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return '';
}
export function getQueryObject(url) {
  var query = {};
  var hash = url.substr(url.indexOf("?") + 1);
  var hashArray = hash.split('&');
  for (var i = 0; i < hashArray.length; i++) {
    query[hashArray[i].split('=')[0]] = hashArray[i].split('=')[1];
  }
  return query;
}
// 业务成功/失败上报
export function bizThenFunction(bizOpts, bizCode) {
  var _a = bizOpts.response,
    response = _a === void 0 ? {} : _a,
    url = bizOpts.url,
    params = bizOpts.params;
  var status = response.status,
    _b = response.data,
    data = _b === void 0 ? {} : _b;
  var options = {
    networkCode: status,
    statusCode: 0,
    errType: '',
    url: url,
    params: params,
    response: response
  };
  if (status < 400) {
    var code = (data || {}).code;
    if (code === bizCode) {
      options.statusCode = SUCCESS_CODE;
    } else {
      options.errType = 'bizErr';
      options.statusCode = FAIL_CODE;
    }
  } else {
    options.errType = 'requestErr';
  }
  owlErrorReport(options);
}
export function bizCatchFun(bizCatchOpts) {
  var _a = bizCatchOpts.error,
    error = _a === void 0 ? '' : _a,
    _b = bizCatchOpts.url,
    url = _b === void 0 ? '' : _b,
    params = bizCatchOpts.params;
  var options = {
    errType: '',
    url: url,
    error: error,
    params: params
  };
  if (String(error).indexOf('timeout') > -1) {
    options.errType = 'timeout';
  } else if (String(error).indexOf('Network Error') > -1) {
    options.errType = 'networkErr';
  } else {
    options.errType = 'requestErr';
  }
  owlErrorReport(options);
}
export function regErrorFun(regError) {
  var _a = regError.params,
    params = _a === void 0 ? {} : _a;
  var options = {
    errType: 'regErr',
    params: params
  };
  if (options.errType) {
    window.Owl && window.Owl.addError && window.Owl.addError({
      name: "[" + options.errType + "]",
      msg: params
    }, {
      level: 'warn',
      category: 'customError'
    });
  }
}
export function owlErrorReport(options) {
  var opts = options;
  switch (opts.errType) {
    case 'timeout':
      opts.networkCode = ERR_CODE.TIMEOUT; // 【网络失败】网络码 请求超时
      opts.statusCode = ERR_CODE.TIMEOUT; // 【业务失败】业务码 请求超时
      break;
    case 'networkErr':
      opts.networkCode = ERR_CODE.NETWORK_ERR; // 【网络失败】网络问题/网关问题
      opts.statusCode = ERR_CODE.NETWORK_ERR; // 【业务失败】网络问题/网关问题
      break;
    case 'requestErr':
      opts.networkCode = ERR_CODE.REQUEST_ERR; // 【网络失败】请求失败
      opts.statusCode = ERR_CODE.REQUEST_ERR; // 网络失败】请求失败
      break;
  }
  window.Owl && window.Owl.addApi({
    name: opts.url,
    statusCode: opts.statusCode,
    networkErr: opts.networkCode
  });
  if (opts.errType) {
    window.Owl && window.Owl.addError && window.Owl.addError({
      name: "[" + opts.errType + "]" + opts.url,
      msg: JSON.stringify(opts)
    }, {
      level: 'warn',
      category: 'ajaxError'
    });
  }
}
export function getUserInfo(successFun, failFun) {
  if (isStandardKNB && msi && msi.getUserInfo) {
    msi.getUserInfo({
      success: function success(res) {
        if (res.userInfo.userId && res.userInfo.userId !== '-1') {
          successFun(res.userInfo);
        } else {
          failFun();
        }
      },
      fail: function fail() {
        failFun();
      }
    });
    return;
  }
  KNB.ready(function () {
    KNB.getUserInfo({
      success: function success(user) {
        if (user.userId && user.userId !== '-1') {
          successFun(user);
        } else {
          failFun();
        }
      },
      fail: function fail() {
        failFun();
      }
    });
  });
}
/**
 * 在入口页面重置 localStorage 中关于业务参数的缓存，目前有两个业务参数：业务方(businessSource)，业务场景(businessSourceFrom)
 * @param sourceParamName 需要重置的业务参数名称
 * @returns
 */
export function resetEntryLocalSourceParam(sourceParamName) {
  try {
    var query = getQueryObject(location.href);
    var querySourceParam = query[sourceParamName] || '';
    var STORAGE_KEY = SOURCE_STORAGE_KEYS[sourceParamName];
    localStorage.setItem(STORAGE_KEY, querySourceParam);
  } catch (error) {
    console.warn("resetEntryLocalSourceParam: " + sourceParamName + " fail", error);
  }
}
export function resetEntryLocalSourceParams() {
  resetEntryLocalSourceParam('businessSource');
  resetEntryLocalSourceParam('businessSourceFrom');
}
// 重写 VueRouter push、replace 方法
export function resetVueRouter(Router) {
  // 保存原来的 push 函数
  var routerPush = Router.prototype.push;
  // 保存原来的 replace 函数
  var routerReplace = Router.prototype.replace;
  // 重写 push 函数
  Router.prototype.push = function push(location) {
    location = handleLocation(location);
    // 调用原来的 push 函数
    return routerPush.call(this, location).catch(function (error) {
      return error;
    });
  };
  // 重写 replace 函数
  Router.prototype.replace = function replace(location) {
    location = handleLocation(location);
    // 调用原来的 replace 函数
    return routerReplace.call(this, location).catch(function (error) {
      return error;
    });
  };
  function handleLocation(location) {
    var query = getQueryObject(window.location.href);
    var querySource = query.businessSource || '';
    var querySourceFrom = query.businessSourceFrom || '';
    // 自动将 businessSource, businessSourceFrom 参数向后传递
    if (typeof location === 'string') {
      location = {
        path: location,
        query: {
          businessSource: querySource,
          businessSourceFrom: querySourceFrom
        }
      };
    }
    if (Object.prototype.toString.call(location) === '[object Object]') {
      // @ts-ignore
      location.query = location.query || {};
      // @ts-ignore
      location.query.businessSource = location.query.businessSource || querySource;
      location.query.businessSourceFrom = location.query.businessSourceFrom || querySourceFrom;
    }
    return location;
  }
}
/**
 * 标准容器下的appID枚举
 * https://mobile.sankuai.com/apps
 */
export var StandardKnbAppId;
(function (StandardKnbAppId) {
  /**
   * 美团
   */
  StandardKnbAppId["MEITUAN"] = "10";
  /**
   * 美团外卖
   */
  StandardKnbAppId["MEITUAN_WAIMAI"] = "11";
  /**
   * 点评
   */
  StandardKnbAppId["DIANPING"] = "1";
})(StandardKnbAppId || (StandardKnbAppId = {}));
var checkIsHarmony = function checkIsHarmony(ua) {
  // 兼容鸿蒙 KNB Native beta/0.1.9 版本实现，还没有 'KNB' 标识
  // OpenHarmony 系统注入不确定大小写，MSI 确定大写
  var harmonyKeywords = {
    os: 'openharmony',
    bridge: 'MSI/'
  };
  // 如果是鸿蒙容器环境，那么加载鸿蒙环境实现
  var isHarmony = ua.toLocaleLowerCase().indexOf(harmonyKeywords.os) >= 0 && ua.indexOf(harmonyKeywords.bridge) >= 0;
  return isHarmony;
};
var getMsiAppInfo = function getMsiAppInfo() {
  try {
    var isStandardKnb = KNB && KNB.env && KNB.env.isStandardKnb;
    if (isStandardKnb && typeof msi !== 'undefined' && msi.getAppBaseInfo) {
      var appBaseInfo = msi.getAppBaseInfo();
      var appID = appBaseInfo._mt.appID;
      var isMsiMTApp_1 = appID === StandardKnbAppId.MEITUAN;
      var isMsiMTWaimaiApp_1 = appID === StandardKnbAppId.MEITUAN_WAIMAI;
      var isMsiDPApp_1 = appID === StandardKnbAppId.DIANPING;
      var isMsiApp_1 = isMsiMTApp_1 || isMsiMTWaimaiApp_1 || isMsiDPApp_1;
      return {
        isMsiMTApp: isMsiMTApp_1,
        isMsiMTWaimaiApp: isMsiMTWaimaiApp_1,
        isMsiDPApp: isMsiDPApp_1,
        isMsiApp: isMsiApp_1
      };
    } else {
      return {
        isMsiMTApp: false,
        isMsiMTWaimaiApp: false,
        isMsiDPApp: false,
        isMsiApp: false
      };
    }
  } catch (e) {
    return {
      isMsiMTApp: false,
      isMsiMTWaimaiApp: false,
      isMsiDPApp: false,
      isMsiApp: false
    };
  }
};
export function initMsiAppInfo() {
  return __awaiter(this, void 0, void 0, function () {
    var isStandardKnb, _a, isMsiMTApp, isMsiMTWaimaiApp, isMsiDPApp, isMsiApp;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          isStandardKnb = KNB && KNB.env && KNB.env.isStandardKnb;
          if (!isStandardKnb) return [3 /*break*/, 2];
          return [4 /*yield*/, msi.load()];
        case 1:
          _b.sent();
          _b.label = 2;
        case 2:
          _a = getMsiAppInfo(), isMsiMTApp = _a.isMsiMTApp, isMsiMTWaimaiApp = _a.isMsiMTWaimaiApp, isMsiDPApp = _a.isMsiDPApp, isMsiApp = _a.isMsiApp;
          return [2 /*return*/, {
            isMsiMTApp: isMsiMTApp,
            isMsiMTWaimaiApp: isMsiMTWaimaiApp,
            isMsiDPApp: isMsiDPApp,
            isMsiApp: isMsiApp,
            isMTApp: /MeituanGroup/i.test(UA) || /ai\.meitest/i.test(UA) || isMsiMTApp,
            isWMApp: /meituanwaimai-c/i.test(UA) || isMsiMTWaimaiApp,
            isWMBApp: /(meituanwaimai-b|meituanwaimaibusiness)/i.test(UA) || isMsiMTWaimaiApp,
            isPeiSongApp: /(com.meituan.banma.paotui|com.meituan.banma.paotuib.ep)/i.test(UA) || isMsiMTWaimaiApp,
            isWaimai: isWMApp || isWMBApp,
            isIOS: UA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/i) != null,
            isAndroid: /android/i.test(UA),
            isWX: /micromessenger/i.test(UA),
            isWXApp: isWX && /miniprogram/i.test(UA),
            isDPApp: getApp() === 'dianping-nova' || isMsiDPApp,
            isAPP: isMTApp || isWaimai || isDPApp || isMsiApp,
            isHarmony: checkIsHarmony(UA) || /Harmony/i.test(UA)
          }];
      }
    });
  });
}
export var isMsiMTApp = (_a = getMsiAppInfo(), _a.isMsiMTApp),
  isMsiMTWaimaiApp = _a.isMsiMTWaimaiApp,
  isMsiDPApp = _a.isMsiDPApp,
  isMsiApp = _a.isMsiApp;
export var UA = window.navigator.userAgent;
export var isMTApp = /MeituanGroup/i.test(UA) || /ai\.meitest/i.test(UA) || isMsiMTApp;
export var isWMApp = /meituanwaimai-c/i.test(UA) || isMsiMTWaimaiApp;
export var isWMBApp = /(meituanwaimai-b|meituanwaimaibusiness)/i.test(UA);
export var isPeiSongApp = /(com.meituan.banma.paotui|com.meituan.banma.paotuib.ep)/i.test(UA);
export var isWaimai = isWMApp || isWMBApp;
export var isIOS = UA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/i) != null;
export var isAndroid = /android/i.test(UA);
export var isWX = /micromessenger/i.test(UA);
export var isWXApp = isWX && /miniprogram/i.test(UA);
export var isDPApp = getApp() === 'dianping-nova' || isMsiDPApp;
export var isAPP = isMTApp || isWaimai || isDPApp || isMsiApp;
export var isStandardKNB = KNB && KNB.env && KNB.env.isStandardKnb || /KNB\//i.test(UA) && /MSI\//i.test(UA);
export var isHarmony = checkIsHarmony(UA) || /Harmony/i.test(UA);
/**
 * 鸿蒙系统、小程序内，loading 页跳转到申请开票页, URL 需增加 wxapp_h5_payment 参数，用于唤起收银台; 增加 uuid，用于获取用户地址
 */
export function addUrlPayParams(url) {
  if (url.indexOf('result') !== -1 || !isWXApp) {
    return url;
  }
  var queryString = getAllQueryString();
  var uuid = queryString.wm_uuid || queryString.dp_uuid || queryString.uuid || '';
  url = url + "&wmUuid=" + uuid + "&wxapp_h5_payment=1";
  return url;
}